import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { globalTranslationKeys } from '../../../enums';
import { marketTypes } from '../../../helpers/constants';

export const GameSpecificCheckHashPopupTopSection = ({ t, isFromBetHistory, currentData }) => {
  return (
    <div className='monti-check-hash-popup-content'>
      {isFromBetHistory ? (
        <div className='monti-bet-type-box'>
          <div className='monti-bet-type-row'>
            <span className='monti-bet-type-name'>{t(globalTranslationKeys.BetType)}</span>
          </div>
          <div className='monti-bet-type-row'>
            <span className='monti-bet-type-value'>{currentData?.additionalParams.number}</span>
            <i
              className={`ui-lib-over-arrow-2 ${
                currentData?.additionalParams.marketType === marketTypes.Under ? 'under' : 'over'
              }`}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className='monti-round-info-hexagon'>
        <span className='monti-round-info-hexagon-txt'>{currentData?.roundData}</span>
      </div>
    </div>
  );
};

export const AboutHashInnerContent = ({ t }) => {
  return (
    <>
      <p className='pr-f-text'>{t('FAIRNESS_P1')}</p>
      <p className='pr-f-text w-b-ba'>
        8860731B4F9523DD3A1AA686A237BB89CC5EC01448ADFFE6FFE64F12E3015C648904D3761689EA0B642B8E0A8A250ADA0773247B792541B2EE4FD89EFFA3283B
      </p>
      <p className='pr-f-text'>{t('FAIRNESS_P2')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P3')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P4')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P5')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P6')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P7')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P8')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P9')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P10')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P11')}</p>
      <p className='pr-f-text w-b-ba'>
        8860731B4F9523DD3A1AA686A237BB89CC5EC01448ADFFE6FFE64F12E3015C648904D3761689EA0B642B8E0A8A250ADA0773247B792541B2EE4FD89EFFA3283B
      </p>
      <p className='pr-f-text' key={Date.now()}>
        {t('FAIRNESS_P12')}
      </p>
    </>
  );
};

export const HelpPopupContent = () => {
  const t = useTranslation();
  const {
    GAME_RULES_P1,
    GAME_RULES_P2,
    GAME_RULES_P3,
    GAME_RULES_P4,
    GAME_RULES_P5,
    GAME_RULES_P6,
    GAME_RULES_P7,
    GAME_RULES_P8,
    CancelationMessage1,
    MalfunctionMessage2,
    Rtp,
  } = globalTranslationKeys;

  //

  return (
    <>
      <p>{t(GAME_RULES_P1)}</p>
      <p>{t(GAME_RULES_P2)}</p>
      <p>{t(GAME_RULES_P3)}</p>
      <p>{t(GAME_RULES_P4)}</p>
      <p>{t(GAME_RULES_P5)}</p>
      <p>{t(GAME_RULES_P6)}</p>
      <p>{t(GAME_RULES_P7)}</p>
      <p>{t(GAME_RULES_P8)}</p>
      <p>
        {t(CancelationMessage1)}
        <br />
        {t(MalfunctionMessage2)}
      </p>
      <p>{t(Rtp)}</p>
    </>
  );
};
